<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  disabled: {
    default: false,
    type: Boolean
  }
});

const store = useStore();
const pageSource = computed(() => store.getters["checkout/pageSource"]);
const userType = computed(() => store.getters["checkout/userType"]);
const paypalOrderCreateData = computed(() => store.getters["checkout/paypalOrderCreateData"]);
const orderNumber = computed(() => store.getters["checkout/orderNumber"]);
const countryCode = computed(() => store.getters["checkout/countryCode"]);

const loadPaypalButtons = () => {
  window?.jiffyThreads?.payments.loadPaypalButtons("#js-paypal-buttons-container", () => ({
    countryCode: countryCode.value,
    height: 52,
    orderNumber: orderNumber.value,
    pageSource: pageSource.value,
    paypalOrderCreateData: paypalOrderCreateData.value,
    userType: userType.value
  }));
};

onMounted(() => {
  loadPaypalButtons();
});
</script>

<template>
  <div
    id="js-paypal-buttons-container"
    class="paypal"
    :class="{ 'paypal--disabled': props.disabled }"
  ></div>
</template>

<style scoped lang="scss">
.paypal {
  &--disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
